import { render } from "./hero-banner.vue?vue&type=template&id=58504d22&scoped=true"
import script from "./hero-banner.vue?vue&type=script&lang=js"
export * from "./hero-banner.vue?vue&type=script&lang=js"

import "./hero-banner.vue?vue&type=style&index=0&id=58504d22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58504d22"]])

export default __exports__